import React from 'react';
import './ValidationReferencesPriceNotOKComment.scss';
import IconItem from '../../../../../../components/Item/IconItem/IconItem';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import DefaultButton from 'components/buttons/DefaultButton/DefaultButton';
import { Trans, useTranslation } from 'react-i18next';
import TextareaInput from 'components/inputs/TextareaInput/TextareaInput';
import { useDispatch } from 'react-redux';
import { setCloseModal } from 'store/slices/proformaAutomotorModal.slice';

type Props = {
  setOpenModal: (e: boolean) => void;
  setStepModal: (e: string) => void;
};


const ValidationReferencesPriceNotOKComment: React.FC<Props> = (props) => {

  const { t } = useTranslation();
  const proformaFile = JSON.parse(localStorage.getItem('proformaFileInProgress') as string);
  const dispatch = useDispatch();

  const handleClose = () => {
    props.setOpenModal(false);
    dispatch(setCloseModal(true));
  };

  const [message, setMessage] = React.useState<string>('');

  const addComment = () => {
    if (message.length > 0) {
      proformaFile.comment_references_price_not_ok = message;
      localStorage.setItem('proformaFileInProgress', JSON.stringify(proformaFile));
    }

    props.setStepModal('ValidationReferencesMOQ');
  };


  return (
    <div className="validation-custumer-order-comment-modal" >
      <div className="close upload_order_info_price_not_ok_comment_close">
        <IconItem icon={faClose} onClick={() => { handleClose(); }} />
      </div>
      <div className="validation-customer-modal-body">
        <div className="validation-customer-modal-row">
          <div className="validation-customer-modal-title">{t('_AGP_rates_not_approved')}</div>
          <div className="validation-customer-modal-subtitle">
            <Trans
              i18nKey="_validation_message_not_approved"
              components={{ bold: <br /> }}

            />
          </div>
        </div>
        <div className="validation-customer-modal-row">
          <TextareaInput noResize rows={10} onChange={(e) => setMessage(e.target.value)} />
        </div>

        <div className="validation-customer-modal-row">
          <div className="validation-customer-modal-button">
            <DefaultButton className="validation-customer-modal-btn upload_order_info_price_not_ok_comment" text={t('_send_my_order_as_price_not_ok_comment')} onClick={() => { addComment(); }} />


          </div>

        </div>

      </div>
    </div>
  );

};

ValidationReferencesPriceNotOKComment.displayName = 'ValidationReferencesPriceNotOKComment';

export default ValidationReferencesPriceNotOKComment;